import React, { useState } from 'react';
import axios from 'axios';
import { MainWrap } from '../../utilities/Shared';

const Unlink = () => {
  const [job, setJob] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);


  // ... imports & states same as before ...

const unlinkJob = async () => {
  const jobId = job.trim();
  if (!jobId || !/^\d+$/.test(jobId)) {
    setStatus(!jobId ? 'Please enter a job ID' : 'Job ID must be a number');
    return;
  }

  if (!window.confirm(`Really unlink/delete job ${jobId}? This affects MySQL + MongoDB.`)) {
    return;
  }

  setLoading(true);
  setStatus('');

  try {
    // Step 1: Delete from MySQL via PHP
    const formData = new URLSearchParams();
    formData.append('jobid', jobId);

    const phpResponse = await axios.post(
      'https://highgroundsoftware.com/dash/dashboard/php/unlink',
      formData,
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      }
    );

    console.log('PHP response:', phpResponse.data);

    
   
    let h = {jobid:jobId}

const mongoResponse = await axios.delete(
  'https://highgroundapi.herokuapp.com/jobs/unlink',
  {
    data: { jobid: jobId }          // ← body goes here
  }
);

  

    setStatus('Job successfully unrolled!');
    setJob('');
  } catch (error) {
    console.error('Error during unlink:', error);

    let msg = 'Failed to unlink job';

    if (error.response) {
      msg = error.response.data?.message ||
            `Server error (${error.response.status})`;
    } else if (error.request) {
      msg = 'No response from server – check network/CORS';
    } else {
      msg = error.message;
    }

    setStatus(`Error: ${msg}`);
  } finally {
    setLoading(false);
  }
};

// rest of component (return JSX) stays the same

  // const unlinkJob = async () => {
  //   const jobId = job.trim();
  //   if (!jobId) {
  //     setStatus('Please enter a job ID');
  //     return;
  //   }

  //   // Optional: enforce numeric job ID (most systems expect this)
  //   if (!/^\d+$/.test(jobId)) {
  //     setStatus('Job ID must be a number');
  //     return;
  //   }

  //   if (!window.confirm(`Really unlink / delete job ${jobId}? This cannot be undone.`)) {
  //     return;
  //   }

  //   setLoading(true);
  //   setStatus('');

  //   try {
  //     const formData = new URLSearchParams();
  //     formData.append('jobid', jobId);

  //     const response = await axios.post(
  //       'https://highgroundsoftware.com/dash/dashboard/php/unlink',
  //       formData,
  //       {
  //         headers: {
  //           'Content-Type': 'application/x-www-form-urlencoded',
  //         },
  //         // withCredentials: true,   // uncomment only if session/cookies are required
  //       }
  //     );

  //     console.log('Response:', response.data);
  //     setStatus('Job successfully unrolled!');
  //     setJob(''); // clear input after success
  //   } catch (error) {
  //     console.error('Error unlinking job:', error);

  //     let msg = 'Failed to unlink job';

  //     if (error.response) {
  //       // Server responded with error status (4xx/5xx)
  //       msg = error.response.data?.message || 
  //             error.response.statusText || 
  //             `Server error (${error.response.status})`;
  //     } else if (error.request) {
  //       // No response received (CORS, network, timeout, etc.)
  //       msg = 'No response from server – check network or CORS';
  //     } else {
  //       msg = error.message;
  //     }

  //     setStatus(`Error: ${msg}`);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <MainWrap>
      <div style={{ marginTop: '30px', width: '40%' }}>
        <input
          type="text"
          value={job}
          onChange={(e) => setJob(e.target.value)}
          placeholder="Enter Job ID"
          disabled={loading}
          style={{ padding: '8px', width: '180px' }}
        />
        &nbsp;&nbsp;&nbsp;
        <button
          type="button"
          onClick={unlinkJob}
          disabled={loading || !job.trim()}
          style={{
            padding: '8px 16px',
            background: loading ? '#ccc' : '#e63946',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer',
          }}
        >
          {loading ? 'Processing...' : 'Unroll Job'}
        </button>

        {status && (
          <div
            style={{
              marginTop: '16px',
              padding: '10px',
              background: status.includes('Error') ? '#ffebee' : '#e8f5e9',
              color: status.includes('Error') ? '#c62828' : '#2e7d32',
              borderRadius: '4px',
              fontWeight: '500',
            }}
          >
            {status}
          </div>
        )}
      </div>
    </MainWrap>
  );
};

export default Unlink;